(() => {
  if (window.__imBoldCloneStateSync) return;
  window.__imBoldCloneStateSync = true;

  const nativeSelector = '.product-form--atc-button[data-product-atc]:not(.bold_clone)';
  const cloneSelector = '.product-form--atc-button.bold_clone';
  const lastState = new WeakMap();
  const changedForms = new Set();
  const relabeledForms = new Set();
  let scheduled = false;

  function sync() {
    scheduled = false;
    document.querySelectorAll('form[data-product-form]').forEach(form => {
      const native = form.querySelector(nativeSelector);
      if (!native) return;
      const disabled = native.disabled || native.classList.contains('disabled');
      const label = (native.querySelector('.atc-button--text') || native).textContent.trim();
      form.querySelectorAll(cloneSelector).forEach(clone => {
        const previous = lastState.get(clone);
        const newPair = previous?.native !== native;
        const syncDisabled = newPair || changedForms.has(form) || previous.disabled !== disabled || (disabled && !clone.disabled);
        const syncLabel = newPair || relabeledForms.has(form) || previous.label !== label;
        lastState.set(clone, { native, disabled, label });
        if (syncDisabled) {
          if (clone.disabled !== disabled) clone.disabled = disabled;
          if (clone.classList.contains('disabled') !== disabled) clone.classList.toggle('disabled', disabled);
          if (clone.hasAttribute('aria-disabled') && clone.getAttribute('aria-disabled') !== String(disabled)) {
            clone.setAttribute('aria-disabled', String(disabled));
          }
        }
        const target = clone.querySelector('.atc-button--text') || clone;
        if (syncLabel && target.textContent.trim() !== label) target.textContent = label;
      });
    });
    changedForms.clear();
    relabeledForms.clear();
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(sync);
  }

  function start() {
    const observer = new MutationObserver(mutations => {
      let relevant = false;
      mutations.forEach(mutation => {
        const element = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
        const form = element?.closest('form[data-product-form]');
        const native = element?.closest(nativeSelector);
        if (native && form) {
          const disabledClassChanged = mutation.target === native && mutation.attributeName === 'class'
            && (mutation.oldValue || '').split(/\s+/).includes('disabled') !== native.classList.contains('disabled');
          const disabledAttributeChanged = mutation.target === native && mutation.attributeName === 'disabled'
            && (mutation.oldValue !== null) !== native.disabled;
          if (disabledAttributeChanged || disabledClassChanged) {
            changedForms.add(form);
          }
          if (mutation.type === 'characterData' && mutation.oldValue !== mutation.target.textContent) {
            relabeledForms.add(form);
          }
          if (mutation.type === 'childList') {
            const text = nodes => [...nodes].map(node => {
              const labelNode = node.nodeType === 1 && node.querySelector('.atc-button--text');
              return (labelNode || node).textContent;
            }).join('').trim();
            if (text(mutation.removedNodes) !== text(mutation.addedNodes)) relabeledForms.add(form);
          }
          relevant = true;
        }
        if (mutation.attributeName === 'class' && element?.matches(cloneSelector)) relevant = true;
        if (mutation.type === 'childList') {
          relevant = relevant || Boolean(form) || [...mutation.addedNodes].some(node =>
            node.nodeType === 1 && (node.matches('form[data-product-form]') || node.querySelector('form[data-product-form]'))
          );
        }
      });
      if (relevant) schedule();
    });
    observer.observe(document.body, {
      subtree: true,
      childList: true,
      characterData: true,
      characterDataOldValue: true,
      attributes: true,
      attributeFilter: ['disabled', 'class'],
      attributeOldValue: true,
    });
    window.addEventListener('pageshow', schedule);
    schedule();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
